module.exports = __webpack_public_path__ + "img/Weapon_214.25b1b78a.png";